import isNil from 'lodash/isNil';
import max from 'lodash/max';
import {
  InspectionInterface,
  InspectionProposalInterface,
  IdRef,
  InspectionProposal,
  WorksInspectionCost,
} from '../../types';

export const getProposals = (
  inspections: InspectionInterface,
  inspectionProposals: InspectionProposalInterface,
  inspectionIds: IdRef[],
) : InspectionProposal[] => inspectionIds.reduce((proposals, inspectionId) => {
  if (inspections?.[inspectionId]?.scheduledProposalId) {
    const { scheduledProposalId } = inspections[inspectionId];
    const proposal = inspectionProposals[scheduledProposalId];
    if (proposal) proposals.push(proposal);
  }
  return proposals;
}, [] as InspectionProposal[]);

export const getPay = (proposals: InspectionProposal[]): number => (
  proposals.reduce((sum, proposal) => sum + proposal?.contractorFee || 0, 0)
);

export const getPlatformFee = (proposals: InspectionProposal[]): number | null => (
  proposals.some((proposal) => isNil(proposal.totalFee)) ? null
    : proposals.reduce((sum, proposal) => (
      sum + ((proposal?.totalFee || 0) - (proposal?.contractorFee || 0))
    ), 0)
);

export const getPlatformFeePercentage = (proposals: InspectionProposal[]) : number | null => {
  const platformFee = getPlatformFee(proposals);
  if (isNil(platformFee)) return null;

  const totalFee = proposals.reduce((sum, proposal) => sum + (proposal?.totalFee || 0), 0);
  if (totalFee === 0) return null;

  return (platformFee / totalFee) * 100;
};

export const getInspectionCosts = (
  proposals: InspectionProposal[],
  inspections: InspectionInterface,
): WorksInspectionCost[] => (
  proposals.reduce((costs, { inspectionId, totalFee }) => {
    if (inspections?.[inspectionId]) {
      const { id, inspectionType } = inspections[inspectionId];
      costs.push({
        id,
        inspectionType,
        fee: totalFee,
      });
    }
    return costs;
  }, [] as WorksInspectionCost[])
);

export const getIsPaid = (proposals: InspectionProposal[]): boolean => (
  proposals.every((proposal) => proposal?.contractorPaidAt !== null)
);

export const getPaidDate = (proposals: InspectionProposal[]): number | undefined => {
  const paidAtArr: number[] = proposals.map((proposal) => proposal?.contractorPaidAt);
  return max(paidAtArr);
};
